
<template>
  <div>
    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2">
      <el-form-item prop="username" class="item">
        <el-input placeholder="请输入登录账号" v-model="ruleForm2.username" clearable>
        </el-input>
      </el-form-item>
      <el-form-item prop="password" class="item">
        <el-input placeholder="请输入密码" v-model="ruleForm2.password" @keyup.enter.native="handleSubmit" show-password clearable>
        </el-input>
      </el-form-item>
      <p class="checktitle">
        <el-checkbox v-model="checkedstate">7天内自动登录</el-checkbox>
        <router-link to="password" class="r-title" @click.native.prevent="closeLoginDialog">找回密码</router-link>
      </p>
      <p class="loginbtn">
        <el-button type="primary" @click.native.prevent="handleSubmit" :loading="logining" round>登录</el-button>
      </p>
      <p>
        <router-link to="register" class="r-title" @click.native.prevent="closeLoginDialog">立即注册</router-link>
      </p>
    </el-form>
  </div>
</template>

<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'userLogin',
  data() {
    return {
      logining: false,
      ruleForm2: {
        username: '',
        password: ''
      },
      rules2: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
          // { validator: validaePass }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
          // { validator: validaePass2 }
        ]
      },
      checkedstate: true
    }
  },
  methods: {
    closeLoginDialog() {
      // 关闭登录窗口
      this.$emit('getLogindialogFormVisible', false)
    },
    handleSubmit() {
      // eslint-disable-next-line no-unused-vars
      var _this = this
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          // _this.$router.replace('/table');
          this.logining = true
          // NProgress.start();
          var loginParams = { account: this.ruleForm2.username, password: this.ruleForm2.password }
          this.sapost('/dmc/account/login', loginParams, r => {
            console.log()
            this.logining = false
            let { retMsg, retCode, userId, userName, nickName, sex, rank, accountType, accessToken } = r.data
            if (retCode !== '0') {
              this.$message({
                message: retMsg,
                type: 'error'
              })
            } else {
              let user = {
                userId: userId,
                userName: userName,
                nickName: nickName,
                sex: sex,
                rank: rank,
                accountType: accountType,
                accessToken: accessToken
              }
              // 登录成功用户信息存储到session中
              sessionStorage.setItem('user', JSON.stringify(user))
              localStorage.setItem('user', JSON.stringify(user))
              // 关闭登录窗口
              this.$emit('getLogindialogFormVisible', false)
              // 显示用户信息
              this.$emit('sendUserInfo')
              // 登录成功加载购物车信息
              var cartQueryData = {
                'customerid': user.userId,
                'carttype': this.$route.path === '/remoteSenseData' ? '0' : '1',
                'op': 'query',
                'product_geometry_json': [1]
              }
              this.sapost('/dmc/cart/cartoperation', cartQueryData, r => {
                let result = r.data
                let isCheckAll = false
                if (result !== 'null') {
                  let selectedArr = []
                  result.forEach((cart, index) => {
                    if (cart.is_selected) {
                      selectedArr.push(cart)
                    }
                  })
                  if (selectedArr.length === result.length && result.length > 0) {
                    isCheckAll = true
                  }
                  let cartInfo = {
                    cartItems: result,
                    checkAll: isCheckAll
                  }
                  eventBus.$emit('loginSuccess', cartInfo)
                  eventBus.$emit('cartInfo', cartInfo)
                }
                if (this.$route.path.indexOf('regSuccess') !== -1) {
                  this.$router.push('/')
                }
              })
            }
            // 加载头像
            this.showAvatar()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    showAvatar() {
      // 查询头像信息
      var _this = this
      _this.$http.get('/dmc/account/getAvatar', {
        params: {
          account: _this.ruleForm2.username
        },
        responseType: 'arraybuffer'
      }).then(function (response) {
        // 将从后台获取的图片流进行转换
        return 'data:image/png;base64,' + btoa(
          new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
        )
      }).then(function (data) {
        // 接收转换后的Base64图片
        _this.imageUrl = data
        sessionStorage.setItem('imageUrl', JSON.stringify(data))
      })
    }
  }
}
</script>

<style lang="less">
.item {
  padding: 10px 0px;
  margin-bottom: 0px;
  input {
    background-color: rgb(242, 243, 243);
  }
}
.checktitle {
  font-size: 12px;
  color: rgb(191, 194, 198);
  .el-checkbox__inner {
    outline: none;
  }
  .el-checkbox__label {
    color: rgb(191, 194, 198);
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: rgb(28, 203, 150);
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: rgb(28, 203, 150);
    border-color: rgb(28, 203, 150);
  }
  margin-top: 10px;
}
.loginbtn {
  margin-top: 35px;
  margin-bottom: 10px;
  button {
    width: 100%;
    border: none;
    background-color: rgb(28, 203, 150);
  }
  button:hover {
    background-color: rgb(28, 203, 150);
  }
  button:focus {
    background-color: rgb(28, 203, 150);
  }
}
.r-title {
  float: right;
  font-size: 12px;
  color: rgb(191, 194, 198);
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/account/UserLogin.vue